import { isolatedDialog, type IsolatedKey } from 'Addons/fitmentSearch/isolatedKeys';

const isolatedKey: IsolatedKey = isolatedDialog;

export default isolatedKey;
